import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "calendar-dots",
  "use": "calendar-dots-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"calendar-dots\">\n  <path fill-rule=\"evenodd\" d=\"M151.5,217h-12a2,2,0,0,1-2-2V203a2,2,0,0,1,2-2h2v1a1,1,0,0,0,2,0v-1h4v1a1,1,0,0,0,2,0v-1h2a2,2,0,0,1,2,2v12A2,2,0,0,1,151.5,217Zm0-10a1,1,0,0,0-1-1h-10a1,1,0,0,0-1,1v7a1,1,0,0,0,1,1h10a1,1,0,0,0,1-1v-7Zm-4,4h2v2h-2v-2Zm0-3h2v2h-2v-2Zm-3,3h2v2h-2v-2Zm0-3h2v2h-2v-2Zm-3,3h2v2h-2v-2Zm0-3h2v2h-2v-2Z\" transform=\"translate(-137.5 -201)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/calendar-dots.svg
// module id = null
// module chunks = 